import { animationFrameScheduler, interval } from 'rxjs';
import { distinctUntilChanged, endWith, map, takeWhile } from 'rxjs/operators';

const easeOutQuad = (x: number): number => x * (2 - x);

export const buildProgressAnimation = (count: number, startTime: number, duration: number) => interval(0, animationFrameScheduler).pipe(
  map(() => animationFrameScheduler.now() - startTime),
  map((elapsedTime) => elapsedTime / duration),
  takeWhile((progress) => progress <= 1),
  map(easeOutQuad),
  map((progress) => Math.round(progress * count)),
  endWith(count),
  distinctUntilChanged()
);
